import React from "react";
import ReactApexChart from "react-apexcharts";

// let colors = ["#f0f9ba", "#fff1ae", "#fed38c", "#feb669", "#f3854e"];
// let colors = ["#1542E6", "#E63A15", "#59E615", "#fed38c"];
let colors = ["#00b050", "#884106", "#cccc00", "#ff00ff"];

export default class CChart extends React.Component {
  constructor(props) {
    super(props);

    this.state={

    };

  }

  render() {

    const opt = {
    
      series: [{
        name: 'Irrigation Requirement (TMC)',
        // data: [44, 55, 41, 67, 22, 43]
        // data: [10.43, 19.4, 20.44, 13.34, 63.61]
        data: this.props.cap_stats_paddy,
      }],

      options: {
        chart: {
          type: 'bar',
          // height: 220,
          stacked: true,
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          }
        },
        colors: colors,
        responsive: [{
          breakpoint: 480,
          options: {
            legend: {
              position: 'bottom',
              offsetX: -10,
              offsetY: 0
            }
          }
        }],
        plotOptions: {
          bar: {
            horizontal: false,
            //borderRadius: 10
          },
        },

        xaxis: {
          title: {
            text: 'Month'
          },
          type: 'string',
          // categories: ['01/01/2011 GMT', '01/02/2011 GMT', '01/03/2011 GMT', '01/04/2011 GMT', '01/05/2011 GMT', '01/06/2011 GMT'],
          categories: this.props.cap_stats_date,
          // categories: ['July', 'August', 'September', 'October', 'Total'],
        },

        legend: {
          position: 'top',
          fontSize: '12px',
          floating: true,
          offsetY: 0,
          offsetX: 10,
        },
        fill: {
          opacity: 1
        },
        yaxis: {
          title: {
            text: 'FIR(TMC)'
          },
        }
      },
    
    
    };

    return (
      

      <div id="chart" style={{height: '100%'}}>
      <ReactApexChart 
        options={opt.options} 
        series={opt.series} 
        type="bar" 
        height={'90%'} 
      />
      </div>


    );
  }
}